import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorGameShaker} from "../../gameshake/ThorGameShaker";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorSoundConfig} from "../../ThorSoundConfig";

/**
 * Created by Jerker Nord on 2019-05-29.
 */

export class ThorFSBonusFeaturePlayingController extends ReelStopPresentationController {

    public static readonly FS_FEATURE_SELECT_STARTED:string = "ThorFSBonusFeaturePlayingController_fsFeatureSelectStarted";
    public static readonly FS_FEATURE_SELECT_ENDED:string = "ThorFSBonusFeaturePlayingController_fsFeatureSelectEnded";
    public static readonly FS_MJOLNIR_ANIMATION_ABORTED:string = "ThorFSBonusFeaturePlayingController_mjolnirAnimationAborted";

    private _bonusMusicStarted:boolean = false;
    private _currentMode:string;
    private _nextMode:string;

    constructor(index:number) {
        super(index, "ThorFSBonusFeatureController");
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.reelId == 3 && this._bonusMusicStarted == true) {
            if(this._currentMode == ThorGameMode.NUDGE_RESPIN && this._nextMode == ThorGameMode.NORMAL) {
                this._bonusMusicStarted = false;
                SlotGame.sound.playAmbience(ThorSoundConfig.instance.MAIN_GAME_AMBIANCE);
            }
        }
        if(data.reelId == 4) {
            if((this._currentMode == ThorGameMode.NORMAL && this._nextMode == ThorGameMode.NUDGE_RESPIN)
                || (this._currentMode == ThorGameMode.FREESPIN && this._nextMode == ThorGameMode.NUDGE_RESPIN_FS)) {

                this._bonusMusicStarted = true;
                const timeline:TimelineLite = new TimelineLite();
                timeline.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_LANDING));
                if(this._currentMode == ThorGameMode.NORMAL && this._nextMode == ThorGameMode.NUDGE_RESPIN) {
                    timeline.add(() => SlotGame.sound.playAmbience(ThorSoundConfig.instance.FS_GAME_AMBIANCE));
                }
                timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorGameShaker.START_GAME_SHAKING_REEL_AREA)));
                timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorGameShaker.STOP_GAME_SHAKING)), "+=0.4");
            }
        }
    }
}